<script lang="ts">
    import { icons } from "../../../../config"
    import { addProductToCart } from "../../../functions/helper/product"
    import { newNotification } from "../../../store"
    import Icon from "../../widgets/Icon.svelte"
    import ToggleFavorite from "./ToggleFavorite.svelte"
    import ProductQuantity from "./widgets/ProductQuantity.svelte"
    export let variant: BKDFProductVariant
    let quantity = 1

    function noVariantError() {
        newNotification({
            class: "error",
            html: `Bitte wählen Sie eine eindeutige Variante aus. Alle Optionen müssen ausgewählt sein.`,
        })
    }

    function addToCart(variant: BKDFProductVariant, quantity: number) {
        loading = true
        addProductToCart(variant, quantity)
            .then(() => {
                loading = false
            })
            .catch(() => {
                loading = false
            })
    }

    let loading = false
</script>

<div
    id="actionRow"
    class="actionRow"
>
    <ProductQuantity bind:quantity="{quantity}" />
    <button
        disabled="{loading}"
        id="addToCart"
        class="cta primary"
        on:click="{() => {
            if (!variant) return noVariantError()
            addToCart(variant, quantity)
        }}"
    >
        <Icon
            path="{icons.shoppingBag}"
            color="#F3EED9"
            width="{24}px"
            height="{24}px"
            props="{{ 'fill-rule': 'evenodd', 'clip-rule': 'evenodd' }}"
        />
        IN DIE TASCHE</button
    >
    <ToggleFavorite productId="{variant?.parentId}" />
</div>

<style lang="less">
    .actionRow {
        display: flex;
        gap: 12px;
        margin-top: 24px;

        #addToCart {
            border-radius: 2px;
            padding: 0.6rem 1.2rem 0.6rem 1.2rem;
            flex-grow: 1;
            font-weight: 700;
            font-family: Outfit-Bold, sans-serif;
            font-size: 1rem;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
        }
    }
</style>
